import { render, staticRenderFns } from "./RealnameForm.vue?vue&type=template&id=c2425f36&scoped=true"
import script from "./RealnameForm.vue?vue&type=script&lang=js"
export * from "./RealnameForm.vue?vue&type=script&lang=js"
import style0 from "./RealnameForm.vue?vue&type=style&index=0&id=c2425f36&prod&scoped=true&lang=less"
import style1 from "./RealnameForm.vue?vue&type=style&index=1&id=c2425f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2425f36",
  null
  
)

export default component.exports